import { Toast } from '@capacitor/toast'
import { isPwa } from '@ghl/clientportal-core/init'
import { useNotification } from '@gohighlevel/ghl-ui'

export function useCommunitiesToastNotification(): any {
  if (isPwa()) {
    // Return a wrapper around Capacitor's Toast for PWA
    return {
      create: async ({ title }) => {
        await Toast.show({
          text: title,
          duration: 'long',
        })
      },
    }
  } else {
    // Use @gohighlevel/ghl-ui's notification for Web
    const notification = useNotification()
    return notification
  }
}
